import Image from "next/image";

import { Copyright } from "./Copyright";

const MAX_INFOGRAPHIC_WIDTH = 1200;

type ImageData = {
  url: string;
  alt?: string | null;
  title?: string | null;
  copyright?: string | null;
  width?: number | null;
  height?: number | null;
};

export function DoNotCrop(props: { image: ImageData }) {
  const image = props.image;
  const imgWidth = image.width ?? 800;
  const imgHeight = image.height ?? 600;

  const cappedWidth = Math.min(imgWidth, MAX_INFOGRAPHIC_WIDTH);
  const ratio = imgHeight / imgWidth;
  const width = cappedWidth;
  const height = Math.round(cappedWidth * ratio);

  const src = `${image.url}?w=${width}&fit=max&auto=format`;

  return (
    <div className="relative mx-auto max-w-full">
      <Image
        src={src}
        width={width}
        height={height}
        alt={image.alt || image.title || ""}
        className="h-auto w-full"
      />
      <Copyright text={image.copyright} />
    </div>
  );
}
